import React from "react";

//COMPONENTS
// import PostsComponent from "./PostsComponent";
//ROUTES
import AppRoutes from "./views/pages/app-routes/AppRoutes";

import "./App.scss";

function App() {
   return (
      <div className="App">
         <AppRoutes />
      </div>
   );
}

export default App;
